export const Path = {
  MySpace: {
    Root: "/my-space",
    Templates: "templates",
    TemplateWeek: (templateId: string) => `templates/${templateId}/week`,
    Training: "training",
    Programs: "programs",
    Finances: {
      Root: "finances",
      Payouts: "payouts",
      PaymentsToValidate: "payments-to-validate",
      PromoCodes: "promo-codes",
    },
    Explore: "explore",
    Profile: "profile",
    Tutorials: "tutorials",
    ProgramDetails: (programId: string) => `programs/${programId}`,
    ProgramOnOffDetails: (programId: string) => `programs/on-off/${programId}`,
    ProgramSubscribingPage: (programId: string) => `programs/${programId}/subscribing`,
    ProgramOnOffSubscribingPage: (programId: string) => `programs/on-off/${programId}/subscribing`,
  },
  ConfirmEmail: "/confirm-email",
  CreateBox: "/create-box",
  CreateCoach: "/create-coach",
  CreateCoachComplete: "/create-coach/complete",
  CoachOnboarding: "/coach-onboarding",
  Login: "/login",
  Logout: "/logout",
  Welcome: "/welcome",
  Return: "/onboarding/return",
  Box: {
    Root: (id: string) => `/box/${id}`,
    Dashboard: "dashboard",
    Finances: {
      Root: "finances",
      Payouts: "payouts",
      PaymentsToValidate: "payments-to-validate",
      PromoCodes: "promo-codes",
    },
    Profile: "profile",
    Members: "members",
    Offers: "offers",
    Planning: "planning",
    Shop: "shop",
    ProgrammationDetails: (boxProgramId: string) => `programmations/${boxProgramId}`,
    ProgrammationTemplate: (boxProgramId: string) => `programmations/${boxProgramId}/template`,
    ProgrammationSessions: (boxProgramId: string) => `programmations/${boxProgramId}/sessions`,
    Admin: "admin",
    Return: "onboarding/return",
    Refresh: "onboarding/refresh",
    OnboardingStripe: "onboarding/stripe",
    LiteVersion: "onboarding/lite-version",
  },
  Coach: {
    Root: (coachId: string) => `/coach/${coachId}`,
    Dashboard: "dashboard",
    Planning: "planning",
    Members: "members",
    Programmation: "programmation",
    Offers: "offers",
    Finances: "finances",
    Admin: "admin",
  },
  Chat: {
    Root: "chat",
  },
  SignUp: "/sign-up",
  Register: "/register",
  ResetPassword: "/reset-password",
  Root: "/",
  SendCode: "/send-code",
  ProgramInvitation: "/program_invitation",
  ProgramSubscription: "/program_subscription",
  ProgramBundleInvitation: "/program_bundle_invitation",
  ProgramBundleSubscription: "/program_bundle_subscription",
  BoxInvitation: "/box_invitation",
  SharedCoachInvitation: "/shared_coach_invitation",
  BoxStaffInvitation: "/box_staff_invitation",
  BoxOfferInvitation: "/box_offer_invitation",
  BoxParticipation: "/box_participation",
  BoxTransaction: "/box_transaction",
  PrivacyPolicy: "/privacy-policy",
  Eula: "/eula",
  UseCharter: "/use-charter",
  AladinChallenge: "/aladin-challenge",
}
